@if (workStationIds$ | async; as ids) {
  <div>
    <!-- no work station -->
    @if (ids.length === 0) {
      <mat-icon color="warn">warning</mat-icon>
    } @else {
      {{ ids.length }}
    }
    <!--  TODO to show the workStations' names, they would have to be loaded-->
  </div>
}
